import { i18n } from 'i18n';
import { CategoryEnum } from 'shared/api/client/codegen.api';
import { TLabelValue } from 'shared/typings';

export const CATEGORIES = {
	[CategoryEnum.Affiliate]: i18n.t('Affiliate'),
	[CategoryEnum.ContentCreation]: i18n.t('Content Creation'),
	[CategoryEnum.EmailMarketing]: i18n.t('Email Marketing'),
	[CategoryEnum.InfluencerMarketing]: i18n.t('Influencer Marketing'),
	[CategoryEnum.NativeAdvertisement]: i18n.t('Native Advertisement'),
	[CategoryEnum.Other]: i18n.t('Other'),
	[CategoryEnum.SocialMedia]: i18n.t('Social Media'),
	[CategoryEnum.VideoProduction]: i18n.t('Video Production'),
	[CategoryEnum.WebsitePlacements]: i18n.t('Website Placements'),
};

export const CATEGORIES_OPTIONS: TLabelValue[] = Object.entries(CATEGORIES).map(([key, value]) => ({
	value: key,
	label: value,
}));
